import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { App } from '../models/app';
import { LoginService } from './login.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApplicationHubService {
  
  constructor(private http: HttpClient, private loginService: LoginService) {}

  private getHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    if (this.loginService.UserValue?.Username) {
      headers = headers.set('username', this.loginService.UserValue.Username);
    }
    if (this.loginService.UserValue?.Token) {
      headers = headers.set('token', this.loginService.UserValue.Token);
    }
    headers = headers.set('Content-type', 'application/json');
    return headers;
  }

  get(): Observable<App[]> {
    return this.http.get<App[]>(`${environment.api}/applicationhub`, { headers: this.getHeaders() });
  }

  getAppById(id: number): Observable<App> {
    return this.http.get<App>(`${environment.api}/applicationhub/${id}`, { headers: this.getHeaders() });
  }

  post(record: App): Observable<App> {
    return this.http.post<App>(`${environment.api}/applicationhub`, record, { headers: this.getHeaders() });
  }

  deleteAppById(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.api}/applicationhub/${id}`, { headers: this.getHeaders() });
  }
}
